<template>
  <div>
    <b-sidebar
      ref="sb"
      v-model="state"
      v-resize="onResize"
      :width="`${width}px`"
      :no-header-close="true"
      right
      shadow
      no-close-on-esc
      no-close-on-backdrop
    >
      <div v-if="state" class="bg-white px-1 px-lg-3">
        <b-tabs
          v-model="activeTab"
          pills
          small
          :card="false"
          nav-wrapper-class="py-2"
          content-class="px-0"
          @activate-tab="onShowTab"
        >
          <b-tab
            :title="`${$t('fCustomer_feedb_receivedTitle')} (${info.feedbacks.received})`"
            active
          >
            <data-layout
              v-if="userId && activeTab === 0"
              ref="dtReceived"
              :fields="fields"
              :filter="filterReceived"
              :order="order"
              :repo="repo"
              :parent-id="userId"
              :height="height"
              :limit="50"
              card-collapse
              @on-sort="onSort"
            >
              <template #card(header)="{ data: { item }}">
                <user-profile-link v-if="item" :user="item.sender" />
                <div v-if="item" class="small">
                  <span class="text-muted">{{ $dateFormat(item.updated_at) }}</span>
                </div>
                <div
                  v-shtml="item.text"
                  style="overflow:hidden; text-overflow: ellipsis;"
                />
              </template>
              <template #cell(user)="{ data }">
                <user-profile-item
                  :user="data.item.sender"
                />
              </template>
              <template #cell(market)="{ data: { item } }">
                <market-flag :market="item.sender.market" />
              </template>
              <template #cell(updated_at)="{ data }">
                <span v-shtml="data.field.formatter(data.item.updated_at, data.key, data.item)" />
              </template>
              <template #cell(ranking)="{ data }">
                <span
                  v-if="data.item && data.item.sender && data.item.sender.user_profile"
                >
                  {{ data.item.sender.user_profile.ranking }}
                </span>
              </template>
              <template #cell(text)="{ data: { item } }">
                <span
                  v-shtml="item.text"
                  class="d-block"
                  style="width: 260px;"
                />
              </template>
            </data-layout>
          </b-tab>
          <b-tab
            :title="`${$t('fCustomer_feedb_sentTitle')} (${info.feedbacks.sent})`"
          >
            <data-layout
              v-if="userId && activeTab === 1"
              ref="dtSent"
              :fields="fields"
              :filter="filterSent"
              :order="order"
              :repo="repo"
              :parent-id="userId"
              :height="height"
              :limit="50"
              card-collapse
              @on-sort="onSort"
            >
              <template #card(header)="{ data: { item }}">
                <user-profile-link v-if="item" :user="item.receiver" />
                <div v-if="item" class="small">
                  <span class="text-muted">{{ $dateFormat(item.updated_at) }}</span>
                </div>
                <div
                  v-shtml="item.text"
                  style="overflow:hidden; text-overflow: ellipsis;"
                />
              </template>
              <template #card(actions)="{ data: { item } }">
                <b-dropdown-item-button
                  v-if="item && item.weight !== 0"
                  variant="danger"
                  size="sm"
                  @click="onDeleteFeedback(item.id)"
                >
                  <font-awesome-icon icon="trash" class="mr-1" />
                  {{ $t('fCustomer_feedb_delete') }}
                </b-dropdown-item-button>
              </template>
              <template #cell(user)="{ data }">
                <user-profile-item
                  :user="data.item.receiver"
                />
              </template>
              <template #cell(market)="{ data: { item } }">
                <market-flag :market="item.receiver.market" />
              </template>
              <template #cell(updated_at)="{ data }">
                <span v-shtml="data.field.formatter(data.item.updated_at, data.key, data.item)" />
              </template>
              <template #cell(actions)="{ data }">
                <b-btn
                  v-if="data.item.weight !== 0"
                  variant="danger"
                  size="sm"
                  @click="onDeleteFeedback(data.item.id)"
                >
                  {{ $t('fCustomer_feedb_delete') }}
                </b-btn>
              </template>
              <template #cell(weight)="{ data }">
                <span>
                  {{ data.item.weight }}
                </span>
              </template>
              <template #cell(text)="{ data: { item } }">
                <span
                  v-shtml="item.text"
                  class="d-block"
                  style="width: 260px;"
                />
              </template>
            </data-layout>
          </b-tab>
          <b-tab
            :title="`${$t('fCustomer_feedb_readyToSentTitle')} (${info.feedbacks.ready_to_sent})`"
          >
            <data-layout
              v-if="userId && activeTab === 2"
              ref="dtReadyToSent"
              :fields="fields"
              :filter="filterReadyToSent"
              :order="order"
              :repo="repo"
              :parent-id="userId"
              :height="height"
              :limit="50"
              card-collapse
              @on-sort="onSort"
            >
              <template #card(header)="{ data: { item }}">
                <user-profile-link v-if="item" :user="item.receiver" />
                <div v-if="item" class="small">
                  <span class="text-muted">{{ $dateFormat(item.updated_at) }}</span>
                </div>
                <div
                  v-shtml="item.text"
                  style="overflow:hidden; text-overflow: ellipsis;"
                />
              </template>
              <template #cell(user)="{ data }">
                <user-profile-item
                  :user="data.item.receiver"
                />
              </template>
              <template #cell(market)="{ data: { item } }">
                <market-flag :market="item.receiver.market" />
              </template>
              <template #cell(updated_at)="{ data }">
                <span v-shtml="data.field.formatter(data.item.updated_at, data.key, data.item)" />
              </template>
              <template #cell(ranking)="{ data }">
                <span
                  v-if="data.item && data.item.receiver && data.item.receiver.user_profile"
                >
                  {{ data.item.receiver.user_profile.ranking }}
                </span>
              </template>
              <template #cell(text)="{ data: { item } }">
                <span
                  v-shtml="item.text"
                  class="d-block"
                  style="width: 260px;"
                />
              </template>
            </data-layout>
          </b-tab>
        </b-tabs>
      </div>
      <template #header>
        <b-link class="mr-2 text-info" @click="onCancel">
          <font-awesome-icon v-if="isMobile" :icon="['fas', 'arrow-left']" class="mr-2" />
          <span v-shtml="parentTitle" />
        </b-link>
        - {{ displayTitle }}
      </template>
      <template #footer>
        <div v-if="!isMobile" class="d-flex bg-light align-items-center px-3 py-2">
          <strong class="mr-auto" />
          <b-btn variant="secondary" size="sm" @click="onCancel">
            {{ $t('eDoc_form_a_close') }}
          </b-btn>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isServer } from '@/mixins/helpers'

export default {
  name: 'Feedbacks',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      required: true
    },
    idx: {
      type: Number,
      default: -1
    },
    info: {
      type: Object,
      default: () => ({})
    },
    parentTitle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      repo: 'customers.feedbacks',
      filter: [],
      order: { by: 'updated_at', dir: 'desc' },
      state: this.value,
      activeTab: null,
      busy: false,
      height: 500,
      width: 300
    }
  },
  async fetch () {
    if (this.$refs.dtReceive && this.activeTab === 0) {
      await this.$refs.dtReceived.$fetch()
    } else if (this.$refs.dtSent && this.activeTab === 1) {
      await this.$refs.dtSent.$fetch()
    } else if (this.$refs.dtReadyToSent && this.activeTab === 2) {
      await this.$refs.dtReadyToSent.$fetch()
    }
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'device'
    }),
    isMobile () {
      return this.deviceInfo?.type === 'mobile' || false
    },
    displayTitle () {
      return `${this.$t('fCustomer_feedb_title')} (${this.total})`
    },
    filterReceived () {
      return [
        { column: 'receiver_id', value: this.userId, permanent: true },
        { column: '!value', value: 0, permanent: true }
      ].concat(this.filter)
    },
    filterSent () {
      return [
        { column: 'sender_id', value: this.userId, permanent: true },
        { column: '!value', value: 0, permanent: true }
      ].concat(this.filter)
    },
    filterReadyToSent () {
      return [
        { column: 'sender_id', value: this.userId, permanent: true },
        { column: 'value', value: 0, permanent: true }
      ].concat(this.filter)
    },
    total () {
      return this.info?.feedbacks?.tot || 0
    },
    fields () {
      const fields = [
        {
          key: 'id',
          label: this.$t('fCustomer_feedb_f_id'),
          sortable: true,
          class: 'col-1'
        },
        {
          key: 'updated_at',
          label: this.$t('fCustomer_feedb_f_date'),
          sortable: true,
          class: 'col-1',
          formatter: (value, key, item) => {
            return this.$dateFormat(value, 'DD/MM/YYYY<br>HH:mm')
          }
        },
        {
          key: 'user',
          label: this.$t('fCustomer_feedb_f_user'),
          sortable: true,
          class: 'col-4',
          cardFullWidth: true
        },
        {
          key: 'market',
          label: this.$t('fCustomer_feedb_f_market'),
          class: 'col-1 text-center',
          thClass: 'text-center'
        },
        {
          key: 'value',
          label: this.$t('fCustomer_feedb_f_vote'),
          sortable: true,
          class: 'col-1'
        },
        {
          key: 'weight',
          label: this.$t('fCustomer_feedb_f_ranking'),
          sortable: true,
          class: 'col-1'
        },
        {
          key: 'text',
          label: this.$t('fCustomer_feedb_f_text'),
          sortable: true,
          thClass: 'text-center',
          tdClass: 'text-wrap',
          cardFullWidth: true
        }
      ]
      if (this.activeTab === 1) {
        // if feedbacks left tab
        fields.push({
          key: 'actions',
          label: this.$t('fCustomer_feedb_f_actions'),
          sortable: false,
          class: 'col-1'
        })
      }
      return fields
    }
  },
  watch: {
    value (n) {
      this.state = n
      if (!n) {
        this.activeTab = null
        this.flushData()
      }
      this.$nextTick(() => {
        this.calcHeight()
        this.calcWidth()
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.calcHeight()
      this.calcWidth()
    })
  },
  beforeDestroy () {
    //
  },
  methods: {
    ...mapActions({
      call: 'repos/call',
      flush: 'repos/flush',
      flushError: 'repos/flushError',
      deleteFeedback: 'talk/deleteFeedback'
    }),
    onSort (order) {
      this.order = order
    },
    flushData () {
      this.flush({
        repo: this.repo,
        method: 'index',
        id: this.itemId,
        idx: this.idx
      })
    },
    onCancel () {
      this.$emit('input', false)
    },
    onShowTab (activeTab) {
      this.flushData()
      this.$forceUpdate()
      this.$nextTick(() => {
        this.$fetch()
      })
    },
    onDeleteFeedback (id) {
      this.$confirmDanger({
        title: this.$t('eDoc_list_deleteConfirmTitle'),
        body: this.$t('eDoc_list_deleteConfirmBody', { id }),
        okTitle: this.$t('eDoc_list_deleteConfirmOk'),
        cancelTitle: this.$t('eDoc_list_deleteConfirmCancel')
      })
        .then(async (value) => {
          if (value) {
            await this.deleteFeedback(id)
            this.$refs.dtSent.$fetch()
            this.$emit('delete', id)
          }
        })
    },
    calcHeight () {
      if (!isServer && window) {
        const $sidebar = this.$refs.sb?.$el?.querySelector('.b-sidebar-body')
        const $pager = this.$refs.sb?.$el?.querySelector('.pager')
        const $tabsNav = this.$refs.sb?.$el?.querySelector('.b-sidebar-body .tabs .nav')?.parentElement
        const sidebarHeight = $sidebar?.clientHeight || 0
        const pagerHeight = $pager?.clientHeight || 0
        const tabsNavHeight = $tabsNav?.clientHeight || 0
        // calc.
        this.height = sidebarHeight - pagerHeight - tabsNavHeight
      }
    },
    calcWidth () {
      let width = 0
      if (!isServer) {
        if (this.deviceInfo?.type === 'mobile') {
          width = document.body.offsetWidth
        } else {
          width = Math.round(document.body.offsetWidth * 0.80) - (15 * (this.idx + 1))
        }
      }
      this.width = width
    },
    onResize () {
      this.calcHeight()
      this.calcWidth()
    }
  }
}
</script>

<style scoped>

</style>
